import React from "react";
import { useNavigate } from "react-router-dom";

const MyClubMobileHeader = ({
  activeTab,
  setActiveTab,
  isQuickEdit,
  setIsQuickEdit,
  onSave,
  isSaving,
  canInviteStaff,
  isClubAdmin,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-white px-4 py-3 border-y border-[#0000001A] flex justify-between items-center gap-3">
        <div className="text-base font-bold text-black">My Club</div>
        {/* Sent invitations goes in the TITLE row, not the tab row below: the
            tab row's action slot already carries Invite Staff, and at 375 a
            second control there pushed the tab labels onto two lines. This row
            has an empty right half and is the mobile counterpart of the desktop
            header that holds the same link (pages/club/MyClub.js).
            It follows the staff tab, exactly as the desktop link does, and
            carries the SAME ClubAdmin gate: /invitations admits only Agent,
            AgencyAdmin and ClubAdmin (routes/index.js), so for a Staff or Coach
            holding just invite_new_staff it would be a dead link. */}
        {activeTab === "staff" && isClubAdmin && (
          <button
            onClick={() => navigate("/invitations")}
            className="shrink-0 px-3 py-1.5 border border-[#E6E6E6] text-[#1E1E1E] rounded-lg text-xs flex items-center gap-2 hover:bg-gray-50"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.6}
                d="M3 8l9 6 9-6M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
            Sent invitations
          </button>
        )}
        {/* <div
          onClick={handlePlayerAvailability}
          className="border border-[#2283FF] px-4 py-2 flex items-center gap-2 rounded-lg"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.5 1.50015C8.63132 1.36883 8.78722 1.26466 8.9588 1.19359C9.13038 1.12252 9.31428 1.08594 9.5 1.08594C9.68572 1.08594 9.86961 1.12252 10.0412 1.19359C10.2128 1.26466 10.3687 1.36883 10.5 1.50015C10.6313 1.63147 10.7355 1.78737 10.8066 1.95895C10.8776 2.13054 10.9142 2.31443 10.9142 2.50015C10.9142 2.68587 10.8776 2.86977 10.8066 3.04135C10.7355 3.21293 10.6313 3.36883 10.5 3.50015L3.75 10.2502L1 11.0002L1.75 8.25015L8.5 1.50015Z"
              stroke="#2283FF"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <span className="text-xs text-[#2283FF]">Player availability</span>
        </div> */}
      </div>

      <div className="px-4  bg-white flex justify-between items-center  border-b border-[#0000001A]">
        <div className="flex items-center gap-4">
          <div
            onClick={() => setActiveTab("players")}
            className={`py-4  text-xs ${
              activeTab === "players"
                ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                : "text-[#1E1E1ECC]"
            }`}
          >
            My Players
          </div>
          <div
            onClick={() => setActiveTab("staff")}
            className={`py-4  text-xs ${
              activeTab === "staff"
                ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                : "text-[#1E1E1ECC]"
            }`}
          >
            My Staff
          </div>
        </div>

        {/* The action slot follows the ACTIVE TAB, not the page. It used to key
            off `isQuickEdit` alone, so the My Staff tab inherited My Players'
            Quick Edit affordance and never offered Invite Staff — a mobile club
            admin could not invite anyone. Desktop already branches per tab
            (pages/club/MyClub.js); this is the mobile twin of that branch,
            reusing the mobile invite-CTA idiom from
            components/agent/responsive/MySquadMobileHeader.js. */}
        {activeTab === "staff" ? (
          canInviteStaff ? (
            <button
              onClick={() => navigate("/club/invite-staff")}
              className="px-3 py-1.5 bg-[#2283FF] text-white rounded-lg text-xs flex items-center gap-2"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
              Invite Staff
            </button>
          ) : null
        ) : isQuickEdit ? (
          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsQuickEdit(false)}
              className="px-3 py-1.5 text-xs text-[#1E1E1E] border border-[#E6E6E6] rounded-lg hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={!isSaving ? onSave : undefined}
              disabled={isSaving}
              className={`px-3 py-1.5 text-xs rounded-lg ${
                isSaving
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                  : "bg-[#2283FF] text-white hover:bg-blue-600"
              }`}
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        ) : (
          <div
            onClick={() => setIsQuickEdit(!isQuickEdit)}
            className="flex items-center gap-2 bg-[#E9F3FF] px-3 py-2 rounded-lg"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 2.00011H2C1.73478 2.00011 1.48043 2.10547 1.29289 2.29301C1.10536 2.48054 1 2.7349 1 3.00011V10.0001C1 10.2653 1.10536 10.5197 1.29289 10.7072C1.48043 10.8948 1.73478 11.0001 2 11.0001H9C9.26522 11.0001 9.51957 10.8948 9.70711 10.7072C9.89464 10.5197 10 10.2653 10 10.0001V6.50011M9.25 1.25011C9.44891 1.0512 9.71869 0.939453 10 0.939453C10.2813 0.939453 10.5511 1.0512 10.75 1.25011C10.9489 1.44903 11.0607 1.71881 11.0607 2.00011C11.0607 2.28142 10.9489 2.5512 10.75 2.75011L6 7.50011L4 8.00011L4.5 6.00011L9.25 1.25011Z"
                stroke="#2283FF"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span className="text-xs text-[#2283FF]">Quick Edit</span>
          </div>
        )}
      </div>
    </>
  );
};

export default MyClubMobileHeader;
